export default class Presolicitud {
    constructor(
        public numeroSolicitud?: number,
        public descTipoBeneficio?: string,
        public tipoBeneficio?: string,
        public fecDefuncion?: string,
        public fechaDefuncion?: string,
        public fecSolicitud?: string,
        public fechaSolicitud?: string,
        public estado?: string,
        public cedulaBeneficiario?: string,
        public cedulaAfiliado?: string,
        public codCuenta?: string,
        public parentesco?: string,
        public viaRegistro?: string,
        public observaciones?: string,
        public accion?: string,
        public esModificable?: boolean,
        public nombreAfiliado?: string,
        public formaPago?: string,
        public idBanco?: number,
        public tipoCuenta?: string,
        public numeroCuenta?: string,
        public motivo?: string,
        public permiteFirma?: boolean,
        public requiereCambioDoc?: boolean,
        public idTransFirma?: string,
        public formaGeneraSolicitud?: string,
        public viaNotificacion?: string,
        public docFirmado?: boolean,
        public numeroCertTSS?: string,
        public fechaCertTSS?: string,
        public estadoCertTSS?: string,
        public numTelefono?: string,
        public eMail?: string,
        public solCancelada?: boolean,
        public cedulaCoincide?: boolean,
        public nombreCoincide?: boolean,
        public fechaNacimientoCoincide?: boolean,
        public nombreActaNacimientoCoincide?: boolean,
        public fechaNacimientoActaNacimientoCoincide?: boolean,
        public tipoPension?: string,
        public codigoAseguradora?:string,
        public solicitudPagada?: boolean,
        public estadoDesc?: string,
        public tipRetiro?:string,
        public monRetiro?: number,
        public codEtapa?: number,

        public encuestaCompletada?: boolean
    ) {}
}